import { Formik } from "formik";
import React from "react";
import { Form } from "react-bootstrap";
import { Button, ContextualNotification } from '@blueprint/ui';
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import * as yup from "yup";

import {
    FormFooter,
    InputField,
    PasswordField,
} from "../../../common/components/form";
import { FormSubmissionHandler } from "../../../types/common";
import { PageTitle } from "../../../types/pageTitle";

import PublicFormContainer from "./PublicFormContainer";

export type LoginFormValues = {
    username: string;
    password: string;
};

const schema: yup.SchemaOf<LoginFormValues> = yup.object().shape({
    username: yup.string().required(),
    password: yup.string().required(),
});

type LoginFormProps = {
    onSubmit: FormSubmissionHandler<LoginFormValues>;
};

const LoginForm = ({ onSubmit }: LoginFormProps): JSX.Element => {
    document.title = PageTitle.LoginForm;
    return (
        <PublicFormContainer>
            <Formik
                validationSchema={schema}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={onSubmit}
                initialValues={{
                    username: "",
                    password: "",
                }}
            >
                {({ handleSubmit, status, isSubmitting }) => (
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        {status && (
                            <ContextualNotification
                                variant="error"
                                iconAriaLabel="error"
                                closeButton={<></>}
                            >{status}</ContextualNotification>
                        )}
                        <h1>Log on</h1>
                        <InputField
                            name="username"
                            label="Email"
                            type="text"
                            autoFocus
                            required={true}
                        />
                        <PasswordField name="password" label="Password" required={true}/>
                        <ResetLink
                            to="/forgot-password"
                            className="text-decoration-underline text-reset"
                        >
                            Forgot Password?
                        </ResetLink>
                        <FormFooter className="mb-5">
                            <Button
                                type="submit"
                                variant="light.primary"
                                disabled={isSubmitting}
                            >
                                Login
                            </Button>
                        </FormFooter>
                    </Form>
                )}
            </Formik>
        </PublicFormContainer>
    );
};

const ResetLink = styled(NavLink)`
    min-width: unset;
`;


export default LoginForm;
